import ko from "knockout";

export default class SelectListItemModel {
    id: KnockoutObservable<string>;
    name: KnockoutObservable<string>;

    constructor(model: any = {}) {
        this.id = ko.observable<string>(model.id || '');
        this.name = ko.observable<string>(model.name || '');
    }
}